import React, { useEffect, useState } from 'react';
import { Alert } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { User } from '../utils/session';

const DISMISSED_KEY = 'subscription-issue-banner-dismissed';

function getDismissedKey(userUuid: string) {
  return `${DISMISSED_KEY}-${userUuid}`;
}

export function SubscriptionIssueBanner({ user }: { user: User | null }) {
  const { t } = useTranslation(['common']);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (user?.uuid && typeof window !== 'undefined') {
      setDismissed(localStorage.getItem(getDismissedKey(user.uuid)) === 'true');
    }
  }, [user?.uuid]);

  const show = user && !dismissed;

  const handleClose = () => {
    if (user?.uuid && typeof window !== 'undefined') {
      localStorage.setItem(getDismissedKey(user.uuid), 'true');
      setDismissed(true);
    }
  };

  if (!show) return null;

  return (
    <Alert
      variant="light"
      color="blue"
      withCloseButton
      onClose={handleClose}
      closeButtonLabel={t('payment.close-banner')}
      style={{ borderRadius: 0 }}
    >
      {t('payment.subscription-issue-multiple-sessions')}
    </Alert>
  );
}
